export default "__VITE_ASSET__CU3qEtnB__"